import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  goTo({ params }) {
    document.querySelector(`#${params.target}`)?.scrollIntoView()
  }
}
